import * as Sentry from '@sentry/nuxt';

const branch = process.env.B2C_REPO_BRANCH || '';
const environment = process.env.SENTRY_ENVIRONMENT ||
  (branch.endsWith('/main') || branch === 'main' || branch.endsWith('/master') || branch === 'master'
    ? 'production' : 'development');
const release = process.env.SENTRY_RELEASE || undefined;

Sentry.init({
  dsn: 'https://e7f3c9b017c7b4d34d07a06f71491109@o4511263604801536.ingest.de.sentry.io/4511264232374352',

  environment,
  release,

  tracesSampleRate: environment === 'production' ? 0.1 : 1,
  replaysSessionSampleRate: environment === 'production' ? 0.01 : 0.1,
  replaysOnErrorSampleRate: 1.0,

  enableLogs: true,
});
